// Site configuration for SEO and canonical URLs
const SITE_CONFIG = {
  // Production URL - update this to your actual domain
  siteUrl: process.env.REACT_APP_SITE_URL || 'https://novialcraft.com',
  siteName: 'AI Carousel Maker',
  siteDescription: 'Create stunning LinkedIn and Instagram carousels with AI-powered image generation',
};

export default SITE_CONFIG;
